export const getColumns = () => [
  {
    title: "PnL Metrics",
    dataIndex: "pnlType",
    key: "pnlType",
    width: 220,
    render: (value: any, record: any) => (
      <span
        className={
          record.pnlType === "Total Sales" ? "total-sales-cell-pnl" : undefined
        }
      >
        {value}
      </span>
    ),
  },
  {
    title: "As Is",
    dataIndex: "asIs",
    key: "asIs",
    render: (value: any, record: any) => {
      let isNegative = false;

      if (typeof value === "number") {
        isNegative = value < 0;
      } else if (typeof value === "string") {
        const numericValue = parseFloat(value.replace(/[$,%\s]/g, ""));
        if (!isNaN(numericValue)) {
          isNegative = numericValue < 0;
        }
      }

      if (isNegative) {
        return <span className="redSpan">{value}</span>;
      }

      return <span>{value}</span>;
    },
  },
];
